import styled, { css } from 'styled-components';
import Loader from 'react-loader-spinner';
import { NavLink } from 'react-router-dom';
import { StyledButton } from '../../globalStyled';
import { fontDisplay } from '../../theme/typography';

export const StyledTextNavLink = styled(NavLink)`
  color: var(--tol-header-accent);
  text-decoration: underline;
  cursor: pointer;
  margin: 0 5px;
  text-align: center;
  font-size: 14px;
  font-family: 'Archivo', sans-serif;
  font-weight: 500;
`;
export const StyledMailLink = styled.a`
  text-decoration: underline;
  color: var(--tol-header-accent);
  cursor: pointer;
  margin: 0 5px;
  text-align: center;
  font-size: 14px;
  font-family: 'Archivo', sans-serif;
  font-weight: 500;
`;
export const StyledExternalLink = styled.span`
  text-decoration: underline;
  color: #000;
  cursor: pointer;
  margin: 0 5px;
  text-align: center;
  ${({ white }) => {
    if (white) {
      return css`
        color: #fff;
        margin: 0 10px;
      `;
    }
  }}
  ${({ green }) => {
    if (green) {
      return css`
        color: var(--tol-header-accent);
        margin: 0 10px;
        font-family: 'Archivo', sans-serif;
        font-weight: 500;
        font-size: 14px;
      `;
    }
  }}
`;
export const StyledStoreLink = styled.span`
  cursor: pointer;
  text-align: center;
  ${({ white }) => {
    if (white) {
      return css`
        color: #fff;
      `;
    }
  }}
`;
export const StyledPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #EFECEC;
  height: 100vh;
  position: relative;
  overflow-x: hidden;
`;
export const StyledDarkSection = styled.section`
  color: #fff;
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: #0a0b0d;
  z-index: 1;
  height: auto;
  padding-bottom: 100px;
  @media only screen and (max-width: 991px) {
    padding-bottom: 10px;
  }
  > img {
    position: absolute;
    max-height: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    width: auto;
    left: 0;
    top: 0;
    object-fit: cover;
    width: 100%;
    @media only screen and (max-width: 991px) {
      opacity: 0.4;
      /* max-width: 500px; */
      width: 100%;
      left: 0;
    }
  }
`;
export const StyledHeader = styled.header`
  z-index: 2;
  display: flex;
  height: 100px;
  width: 100%;
  background-color: transparent;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 30px;
  @media only screen and (max-width: 991px) {
    padding: 20px;
    justify-content: center;
  }
  img {
    width: 180px;
    margin-right: 10px;
    @media only screen and (max-width: 425px) {
      width: 150px;
    }
  }
`;
export const StyledSection = styled.section`
  height: 100%;
  text-align: center;
  max-width: 985px;
  display: flex;
  justify-content: center;
  align-self: center;
  flex-direction: column;
  position: relative;
  z-index: 1;
  @media only screen and (max-width: 991px) {
    width: 100%;
    margin: 0px;
    padding: 0 25px;
  }
`;

export const StyledLeftHeaderSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  span {
    @media only screen and (max-width: 991px) {
      display: none;
    }
  }

  img {
    width: 180px;
    margin-right: 10px;
    @media only screen and (max-width: 425px) {
      /* width: 150px; */
    }
  }
`;

export const StyledRightHeaderSection = styled.div`
  font-family: Archivo;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  p {
    font-size: 17px;
  }
  @media only screen and (max-width: 991px) {
    flex-direction: column;
  }
`;

export const StyledTitle = styled.h2`
  ${fontDisplay};
  font-weight: 600;
  font-size: 60px;
  text-transform: none;
  line-height: 64px;
  letter-spacing: 0.92px;
  color: #ffffff;
  margin-bottom: 12px;
  b {
    font-weight: inherit;
    font-variation-settings: inherit;
  }
  @media only screen and (max-width: 991px) {
    font-size: 36px;
    line-height: 40px;
    margin-top: 17px;
  }
`;

export const StyledSubtitle = styled.h1`
  font-family: 'Archivo-Regular', sans-serif;
  font-size: 20px;
  opacity: 0.8;
    /* max-width: 400px; */
  line-height: 33px;
  text-transform: none;
  color: #fff;
  font-weight: 400;
  b {
    font-weight: 700;
  }
  @media only screen and (max-width: 991px) {
    font-size: 12px;
    line-height: 20px;
    margin-top: 13px;
    width: 100%;
    padding: 0 20px;
  }
`;
export const StyledButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  transform: scale(0.8);
  @media only screen and (min-width: 991px) {
    transform: translate(0, 40px);
  }
  ${({ loadButtonsSection }) => {
    if (loadButtonsSection) {
      return css`
        flex-direction: row;
        flex-wrap: wrap;
        align-items: center;
        justify-content: flex-start;
        width: 400px;
        button {
          width: auto;
          min-width: 135px;
        }
      `;
    }
  }}
  button {
    &:not(:last-of-type) {
      margin-right: 20px;
    }
  }
`;
export const StyledLoginButton = styled(StyledButton)`
  min-width: 85px;
  height: 50px;
  background: none;
  top: 50px;
  line-height: 64px;
  font-family: 'Archivo', sans-serif;
  font-size: 16px;
  border: none;
  color: var(--tol-header-accent);
  border-radius: 8px;
  padding: 12px 10px;
  svg {
    margin-right: 5px;
  }
  margin: 0 0;
  @media only screen and (max-width: 991px) {
    display: none;
  }
  &:disabled {
    background-color: #ebebeb;
    color: #989898;
    border: 1px solid #ebebeb;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.06);
  }
`;
export const StyledRegisterButton = styled(StyledButton)`
  min-width: 85px;
  height: 50px;
  font-size: 16px;
  background: none;
  font-family: 'Archivo', sans-serif;
  border: none;
  color: var(--tol-header-accent);
  border-radius: 8px;
  padding: 12px 10px;
  svg {
    margin-right: 5px;
  }
  margin: 0 0;
  @media only screen and (max-width: 991px) {
    display: none;
  }
  &:disabled {
    background-color: #ebebeb;
    color: #989898;
    border: 1px solid #ebebeb;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.06);
  }
`;
export const StyledMobileLoginButton = styled(StyledButton)`
  min-width: 85px;
  height: 50px;
  background: none;
  line-height: 64px;
  font-family: 'Archivo', sans-serif;
  font-size: 12px;
  border: none;
  color: var(--tol-header-accent);
  border-radius: 8px;
  padding: 12px 10px;
  svg {
    margin-right: 5px;
  }
  margin: 0 0;
  @media only screen and (min-width: 991px) {
    display: none;
  }
  &:disabled {
    background-color: #ebebeb;
    color: #989898;
    border: 1px solid #ebebeb;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.06);
  }
`;
export const StyledMobileRegisterButton = styled(StyledButton)`
  min-width: 150px;
  height: 37px;
  font-size: 16px;
  padding-bottom: 10px;
  background-color: #000;
  font-family: 'Archivo', sans-serif;
  border: 1px solid #B2B4B6;
  color: var(--tol-header-accent);
  border-radius: 8px;
  padding: 12px 10px;
  svg {
    margin-right: 5px;
  }
  margin-bottom: 0;
  @media only screen and (min-width: 991px) {
    display: none;
  }
  &:disabled {
    background-color: #ebebeb;
    color: #989898;
    border: 1px solid #ebebeb;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.06);
  }
`;
export const StyledLandingButton = styled(StyledButton)`
  width: 100%;
  min-width: 255px;
  height: 40px;
  font-size: 14px;
  background-color: #919191;
  border-radius: 5px;
  border: 1px solid #919191;
  color: #0a0b0d;
  padding: 12px 10px;
  svg {
    margin-right: 5px;
  }
  ${({ rounded }) => {
    if (rounded) {
      return css`
        padding: 12px 45px;
        border-radius: 20px;
      `;
    }
  }}
  ${({ small }) => {
    if (small) {
      return css`
        max-width: 170px;
        min-width: 120px;
        font-size: 16px;
      `;
    }
  }}
  ${({ primary }) => {
    if (primary) {
      return css`
        background-color: #fdca40;
        border: 1px solid #fdca40;
        color: #000;
      `;
    }
  }}
  ${({ dark }) => {
    if (dark) {
      return css`
        background-color: #000;
        border: 1px solid #fff;
        color: #fff;
      `;
    }
  }}
  ${({ brand }) => {
    if (brand) {
      return css`
        background-color: #737df8;
        box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.1);
        color: #fff;
        width: auto;
      `;
    }
  }}
  @media only screen and (max-width: 991px) {
    font-size: 14px;
    height: 35px;

    min-width: 105px;
  }
  &:disabled {
    background-color: #ebebeb;
    color: #989898;
    border: 1px solid #ebebeb;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.06);
  }
`;

export const StyledDetailsContainer = styled.section`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-items: end;
  justify-content: space-between;
  /* background-color: #fff; */
  padding: 20px;
  padding-top: 100px;
  padding-bottom: 45px;
  gap: 32px;
  @media only screen and (max-width: 991px) {
    display: flex;
    justify-items: center;
    flex-direction: column;
    width: 100%;
    padding-top: 0;
    padding-left: 0;
    padding-right: 0;
    & > *:nth-child(1),
    & > *:nth-child(3) {
      background-color: #fff; 
      padding-top: 26px;
    }
  }

  ${({ grey }) => {
    if (grey) {
      return css`
        margin-top: -70px;
        padding: 150px 0;

        background-color: #f8f8f8;
        @media only screen and (max-width: 991px) {
          flex-direction: column-reverse;
          margin-top: 0;
          padding: 50px 0 0 0;
        }
      `;
    }
  }}
  ${({ small }) => {
    if (small) {
      return css`
        padding: 50px 0;
      `;
    }
  }};
`;
export const StyledFooterContainer = styled.section`
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: start;
  justify-items: end;
  justify-content: center;
  background-color: #030202;
  padding: 20px;
  padding-top: 12px;
  padding-bottom: 12px;
  @media only screen and (max-width: 991px) {
    display: none;
    justify-items: center;
    flex-direction: column;
    width: 100%;
  }
`;

export const StyledLoader = styled(Loader)`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
export const StyledContainerLoader = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 10;
  background: white;
`;
export const StyledImgContainer = styled.div`
  width: 355px;
  position: relative;
  text-align: left;
  @media only screen and (max-width: 991px) {
    width: 100%;
    padding: 0 20px;
  }
  ${({ center }) => {
    if (center) {
      return css`
        text-align: center;
        @media only screen and (max-width: 991px) {
          text-align: center;
        }
      `;
    }
  }}
  ${({ right }) => {
    if (right) {
      return css`
        text-align: right;
        @media only screen and (max-width: 991px) {
          text-align: center;
        }
      `;
    }
  }}
  ${({ halfSize }) => {
    if (halfSize) {
      return css`
        width: 50%;
        @media only screen and (max-width: 991px) {
          width: 100%;
          text-align: center;
        }
      `;
    }
  }}
`;
export const StyledImage = styled.img`
  /* width: 100%;
  max-width: 600px; */
  box-shadow: ${({ noShadow }) =>
    noShadow ? 'none' : '0 0 25px 0 rgba(0, 0, 0, 0.3)'};
  @media only screen and (max-width: 991px) {
    padding: 0 25px;
  }
`;
export const StyledDescriptionContainer = styled.div`
  width: 35%;
  padding: 50px;
  margin-left: 50px;
  @media only screen and (max-width: 991px) {
    padding: 50px 15px;
    text-align: center;
    width: 100%;
    margin-left: 0;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
  ${({ halfSize }) => {
    if (halfSize) {
      return css`
        width: 50%;
        @media only screen and (max-width: 991px) {
          width: 100%;
        }
      `;
    }
  }}
  ${({ centered }) => {
    if (centered) {
      return css`
        margin: 0 40px;
        text-align: center;
        @media only screen and (max-width: 991px) {
          margin: 0;
          padding: 20px 15px;
        }
      `;
    }
  }}
`;
export const StyledDescriptionHeader = styled.h2`
  ${fontDisplay};
  font-weight: 600;
  font-size: 30px;
  color: #02170D;
  @media only screen and (max-width: 991px) {
    line-height: 40px;
    font-size: 30px;
  }

  ${({ italic }) => {
    if (italic) {
      return css`
        font-style: italic;
        font-synthesis: style;
      `;
    }
  }}
`;
export const StyledDescriptionSubheader = styled.p`
  margin: 15px 0;
  font-size: 16px;
  font-family: 'Archivo-Regular', sans-serif;
  font-weight: 400;
  color: #02170D;
  line-height: 24px;
`;
export const StyledAuthor = styled.span`
  font-family: 'Archivo', sans-serif;
  font-weight: 100;
  line-height: 50px;
  font-size: 30px;
  @media only screen and (max-width: 991px) {
    font-size: 25px;
  }
`;

export const StyledCenteredContainer = styled.div`
  display: flex;
  gap: 56px;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  @media only screen and (max-width: 991px) {
    flex-wrap: wrap;
    padding-bottom: 20px;
  }
`;

export const StyledFeatured = styled.div`
  font-family: 'Archivo', sans-serif;
  font-weight: 300;
  font-style: italic;
  background-color: #000;
  height: 100%;
  padding: 30px 15px;
  position: absolute;
  right: 0;
  width: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: space-between;
  img {
    max-width: 100px;
    margin: 10px 0;
    @media only screen and (max-width: 991px) {
      max-width: 80px;
    }
  }
  @media only screen and (max-width: 991px) {
    position: relative;
    width: 100%;
    margin-top: 35px;
  }
`;

export const StyledSpan = styled.span`
  font-size: 10px;
  ${({ small }) => {
    if (small) {
      return css`
        font-size: 6px;
      `;
    }
  }}
`;

export const StyledLinksWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 8px;
`;

export const StyledFeaturedImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media only screen and (max-width: 991px) {
    flex-direction: row;
    margin-top: 20px;
  }
`;

export const StyledElipse = styled.div`
  border-radius: 100%;
  width: 136%;
  height: 1914px;
  top: -1118px;
  margin-left: -18%;
  background-color: #023C20;
  position: absolute;
  z-index: 0;
  @media only screen and (max-width: 991px) {
    display: none;
  }
`;
